function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

module.exports = function (i) {
  var e = {};

  function o(t) {
    if (e[t]) return e[t].exports;
    var n = e[t] = {
      i: t,
      l: !1,
      exports: {}
    };
    return i[t].call(n.exports, n, n.exports, o), n.l = !0, n.exports;
  }

  return o.m = i, o.c = e, o.d = function (t, n, i) {
    o.o(t, n) || Object.defineProperty(t, n, {
      enumerable: !0,
      get: i
    });
  }, o.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, o.t = function (n, t) {
    if (1 & t && (n = o(n)), 8 & t) return n;
    if (4 & t && "object" == _typeof(n) && n && n.__esModule) return n;
    var i = Object.create(null);
    if (o.r(i), Object.defineProperty(i, "default", {
      enumerable: !0,
      value: n
    }), 2 & t && "string" != typeof n) for (var e in n) {
      o.d(i, e, function (t) {
        return n[t];
      }.bind(null, e));
    }
    return i;
  }, o.n = function (t) {
    var n = t && t.__esModule ? function () {
      return t.default;
    } : function () {
      return t;
    };
    return o.d(n, "a", n), n;
  }, o.o = function (t, n) {
    return Object.prototype.hasOwnProperty.call(t, n);
  }, o.p = "", o(o.s = 6);
}([function (t, n) {
  t.exports = require("react");
}, function (t, n, i) {
  t.exports = i(2)();
}, function (t, n, i) {
  "use strict";

  var c = i(3);

  function e() {}

  t.exports = function () {
    function t(t, n, i, e, o, r) {
      if (r !== c) {
        var a = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw a.name = "Invariant Violation", a;
      }
    }

    function n() {
      return t;
    }

    var i = {
      array: t.isRequired = t,
      bool: t,
      func: t,
      number: t,
      object: t,
      string: t,
      symbol: t,
      any: t,
      arrayOf: n,
      element: t,
      instanceOf: n,
      node: t,
      objectOf: n,
      oneOf: n,
      oneOfType: n,
      shape: n,
      exact: n
    };
    return i.checkPropTypes = e, i.PropTypes = i;
  };
}, function (t, n, i) {
  "use strict";

  t.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}, function (t, n, i) {},, function (t, n, i) {
  "use strict";

  i.r(n);
  var e = i(0),
      N = i.n(e),
      o = "notification-item",
      g = {
    BOTTOM_LEFT: "bottom-left",
    BOTTOM_RIGHT: "bottom-right",
    BOTTOM_CENTER: "bottom-center",
    TOP_LEFT: "top-left",
    TOP_RIGHT: "top-right",
    TOP_CENTER: "top-center"
  },
      a = {
    TOP: "top",
    BOTTOM: "bottom"
  },
      E = {
    SUCCESS: "success",
    DANGER: "danger",
    INFO: "info",
    DEFAULT: "default",
    WARNING: "warning"
  },
      S = "SLIDING_ANIMATION_EXIT",
      T = "TOUCH_SLIDING_ANIMATION_EXIT",
      h = "REMOVAL",
      r = {
    TIMEOUT: 1,
    CLICK: 2,
    TOUCH: 3,
    MANUAL: 4
  },
      y = {
    DISMISS_ICON_CLASS: "className property of dismissIcon option is required",
    DISMISS_ICON_CONTENT: "content property of dismissIcon option is required",
    DISMISS_ICON_STRING: "className property of dismissIcon option must be a String",
    DISMISS_ICON_INVALID: "content property of dismissIcon option must be a valid React element",
    ANIMATION_IN: "animationIn option must be an array",
    ANIMATION_OUT: "animationOut option must be an array",
    DISMISS_REQUIRED: "duration property of dismiss option is required",
    DISMISS_NUMBER: "duration property of dismiss option must be a Number",
    DISMISS_POSITIVE: "duration property of dismiss option must be a positive Number",
    TITLE_STRING: "title option must be a String.",
    MESSAGE_REQUIRED: "message option is required",
    MESSAGE_STRING: "message option must be a String",
    TYPE_REQUIRED: "type option is required",
    TYPE_STRING: "type option must be a String",
    TYPE_NOT_EXISTENT: "type option not found",
    CONTAINER_REQUIRED: "container option is required",
    CONTAINER_STRING: "container option must be a String",
    DISMISSABLE_CLICK_BOOL: "click property of dismissable option must be a Boolean",
    DISMISSABLE_TOUCH_BOOL: "touch property of dismissable option must be a Boolean",
    WIDTH_NUMBER: "width option must be a Number",
    INSERT_STRING: "insert option must be a String",
    TRANSITION_DURATION_NUMBER: "duration property of transition option must be a Number",
    TRANSITION_CUBICBEZIER_NUMBER: "cubicBezier property of transition option must be a String",
    TRANSITION_DELAY_NUMBER: "delay property of transition option must be a Number",
    TYPE_NOT_FOUND: "custom type not found"
  };

  function I(t) {
    return t ? "".concat(t, "px") : void 0;
  }

  function b(t) {
    return null == t;
  }

  function v(t) {
    return "string" == typeof t;
  }

  function O(t) {
    return "number" == typeof t;
  }

  function _(t) {
    return "boolean" == typeof t;
  }

  function R(t) {
    return !b(t) && t.constructor === Array;
  }

  function w(t, n) {
    var i = n.duration,
        e = n.cubicBezier,
        o = n.delay,
        r = t || {};
    if (b(r.duration) && (r.duration = i), b(r.cubicBezier) && (r.cubicBezier = e), b(r.delay) && (r.delay = o), !O(r.duration)) throw new Error(y.TRANSITION_DURATION_NUMBER);
    if (!v(r.cubicBezier)) throw new Error(y.TRANSITION_CUBICBEZIER_NUMBER);
    if (!O(r.delay)) throw new Error(y.TRANSITION_DELAY_NUMBER);
    return r;
  }

  function C(t) {
    return t === g.BOTTOM_LEFT || t === g.BOTTOM_RIGHT || t === g.BOTTOM_CENTER;
  }

  function M(t) {
    return t === g.TOP_LEFT || t === g.TOP_RIGHT || t === g.TOP_CENTER;
  }

  function A(t) {
    var n = t.type,
        i = t.userDefinedTypes;
    if (t.content) return [o];
    if (!i) return function (t) {
      switch (t.toLowerCase()) {
        case E.DEFAULT:
          return [o, "notification-default"];

        case E.SUCCESS:
          return [o, "notification-success"];

        case E.DANGER:
          return [o, "notification-danger"];

        case E.WARNING:
          return [o, "notification-warning"];

        case E.INFO:
          return [o, "notification-info"];

        default:
          return [o];
      }
    }(n);
    var e = i.find(function (t) {
      return t.name === n;
    });
    if (!e) throw new Error(y.TYPE_NOT_FOUND);
    return [o].concat(e.htmlClasses);
  }

  function s() {
    var t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : 500,
        n = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : "linear",
        i = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : 0,
        e = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : "height";
    return "".concat(t, "ms ").concat(e, " ").concat(n, " ").concat(i, "ms");
  }

  function D(t) {
    return s(t.slidingExit.duration, t.slidingExit.cubicBezier, t.slidingExit.delay, "all");
  }

  function c(t) {
    var n,
        i = t.notification,
        e = t.isFirstNotification,
        o = ((n = i).insert === a.TOP && M(n.container) || n.insert === a.BOTTOM && C(n.container)) && !e,
        r = {};
    return r.animatedElementClasses = A(i), r.rootElementStyle = {
      height: "0",
      marginBottom: 0,
      overflow: "hidden",
      width: I(i.width)
    }, o ? r.animatedElementClasses.push("notification-invisible") : i.animationIn && 0 < i.animationIn.length && i.animationIn.forEach(function (t) {
      return r.animatedElementClasses.push(t);
    }), r.hasSliding = o, r;
  }

  function B(t, n, i) {
    var e,
        o,
        r = 2 * window.innerWidth,
        a = s((e = t.touchSlidingExit.swipe).duration, e.cubicBezier, e.delay, "left"),
        c = s((o = t.touchSlidingExit.fade).duration, o.cubicBezier, o.delay, "opacity");
    return {
      opacity: 0,
      position: "relative",
      transition: "".concat(a, ", ").concat(c),
      left: "".concat(0 <= i - n ? r : -r, "px")
    };
  }

  function p(t, n) {
    var i,
        e,
        o,
        r,
        a,
        c,
        s,
        u,
        l,
        f = T,
        d = S,
        m = n.animatedElementClasses,
        h = n.rootElementStyle,
        p = n.currentX,
        E = n.startX;
    return t.stage === f ? (r = p, a = E, c = A(o = t), {
      childElementStyle: B(o, a, r),
      animatedElementClasses: c,
      rootElementStyle: {
        height: 0,
        marginBottom: 0,
        transition: D(o),
        width: I(o.width)
      }
    }) : t.stage === d ? (u = (s = t).animationOut, l = A(s), u && u.forEach(function (t) {
      return l.push(t);
    }), {
      rootElementStyle: {
        height: 0,
        marginBottom: 0,
        transition: D(s),
        width: I(s.width)
      },
      animatedElementClasses: l
    }) : (i = t.resized ? (e = h, A(t)) : (e = h, m), {
      rootElementStyle: e,
      animatedElementClasses: i
    });
  }

  function k(t, n) {
    return {
      height: "".concat(n, "px"),
      width: I(t.width),
      transition: s(t.slidingExit.duration, t.slidingExit.cubicBezier, t.slidingExit.delay)
    };
  }

  function u(t, n) {
    var i = t,
        e = i.insert,
        o = i.container,
        r = i.dismissIcon,
        a = i.animationIn,
        c = i.animationOut,
        s = i.slidingEnter,
        u = i.slidingExit,
        l = i.touchSlidingBack,
        f = i.touchSlidingExit,
        d = i.dismissable,
        m = i.dismiss,
        h = i.width,
        p = i.id;
    i.id = p || Math.random().toString(36).substr(2, 9), function (t) {
      var n = t.content,
          i = t.title;
      if (!n && !b(i) && !v(i)) throw new Error(y.TITLE_STRING);
    }(i), function (t) {
      var n = t.content,
          i = t.message;

      if (!n) {
        if (!i) throw new Error(y.MESSAGE_REQUIRED);
        if (!v(i)) throw new Error(y.MESSAGE_STRING);
      }
    }(i), i.type = function (t, n) {
      var i = t.content,
          e = t.type;

      if (!i) {
        if (!e) throw new Error(y.TYPE_REQUIRED);
        if (!v(e)) throw new Error(y.TYPE_STRING);
        if (!n && e !== E.SUCCESS && e !== E.DANGER && e !== E.INFO && e !== E.DEFAULT && e !== E.WARNING) throw new Error(y.TYPE_NOT_EXISTENT);
        return e.toLowerCase();
      }
    }(i, n), n && !i.content && (i.userDefinedTypes = function (t, n) {
      var i = t.type;

      if (!t.content && i !== E.SUCCESS && i !== E.DANGER && i !== E.INFO && i !== E.DEFAULT && i !== E.WARNING && n) {
        if (!n.find(function (t) {
          return t.name === i;
        })) throw new Error(y.TYPE_NOT_FOUND);
        return n;
      }
    }(i, n)), i.container = function (t) {
      if (!t) throw new Error(y.CONTAINER_REQUIRED);
      if (!v(t)) throw new Error(y.CONTAINER_STRING);
      return t.toLowerCase();
    }(o), i.insert = function (t) {
      if (!t) return "top";
      if (!v(t)) throw new Error(y.INSERT_STRING);
      return t.toLowerCase();
    }(e), i.dismissable = function (t) {
      var n = t;
      if (!n) return {
        click: !0,
        touch: !0
      };
      if (b(n.click) && (n.click = !0), b(n.touch) && (n.touch = !0), !_(n.click)) throw new Error(y.DISMISSABLE_CLICK_BOOL);
      if (!_(n.touch)) throw new Error(y.DISMISSABLE_TOUCH_BOOL);
      return n;
    }(d), function (t) {
      if (!b(t)) {
        var n = t.className,
            i = t.content;
        if (!n) throw new Error(y.DISMISS_ICON_CLASS);
        if (!v(n)) throw new Error(y.DISMISS_ICON_STRING);
        if (!i) throw new Error(y.DISMISS_ICON_CONTENT);
        if (!N.a.isValidElement(i)) throw new Error(y.DISMISS_ICON_INVALID);
      }
    }(r), i.animationIn = function (t) {
      if (b(t)) return [];
      if (!R(t)) throw new Error(y.ANIMATION_IN);
      return t;
    }(a), i.animationOut = function (t) {
      if (b(t)) return [];
      if (!R(t)) throw new Error(y.ANIMATION_OUT);
      return t;
    }(c), b(h) || (i.width = function (t) {
      if (b(t)) return 0;
      if (!O(t)) throw new Error(y.WIDTH_NUMBER);
      return t;
    }(h));
    return i.slidingEnter = w(s, {
      duration: 600,
      cubicBezier: "linear",
      delay: 0
    }), i.slidingExit = w(u, {
      duration: 600,
      cubicBezier: "linear",
      delay: 0
    }), i.touchSlidingBack = w(l, {
      duration: 600,
      cubicBezier: "ease-in",
      delay: 0
    }), i.touchSlidingExit = f || {}, i.touchSlidingExit.swipe = w(i.touchSlidingExit.swipe || {}, {
      duration: 600,
      cubicBezier: "ease-in",
      delay: 0
    }), i.touchSlidingExit.fade = w(i.touchSlidingExit.fade || {}, {
      duration: 300,
      cubicBezier: "ease-in",
      delay: 0
    }), function (t) {
      if (t) {
        if (b(t.duration)) throw new Error(y.DISMISS_REQUIRED);
        if (!O(t.duration)) throw new Error(y.DISMISS_NUMBER);
        if (t.duration < 0) throw new Error(y.DISMISS_POSITIVE);
      }
    }(m), i;
  }

  function l(t) {
    return (l = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
      return _typeof(t);
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
    })(t);
  }

  function f(t, n) {
    for (var i = 0; i < n.length; i++) {
      var e = n[i];
      e.enumerable = e.enumerable || !1, e.configurable = !0, "value" in e && (e.writable = !0), Object.defineProperty(t, e.key, e);
    }
  }

  function d(t) {
    return (d = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
      return t.__proto__ || Object.getPrototypeOf(t);
    })(t);
  }

  function m(t) {
    if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t;
  }

  function P(t, n) {
    return (P = Object.setPrototypeOf || function (t, n) {
      return t.__proto__ = n, t;
    })(t, n);
  }

  var L = function (t) {
    function o(t) {
      var n, i, e;
      return function (t, n) {
        if (!(t instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, o), i = this, (n = !(e = d(o).call(this, t)) || "object" !== l(e) && "function" != typeof e ? m(i) : e).endOfSmartSliding = !1, n.onTransitionEnd = n.onTransitionEnd.bind(m(n)), n.onNotificationClick = n.onNotificationClick.bind(m(n)), n.setDismissTimeout = n.setDismissTimeout.bind(m(n)), n.onSmartSlidingEnd = n.onSmartSlidingEnd.bind(m(n)), n.onTouchSmartSlidingEnd = n.onTouchSmartSlidingEnd.bind(m(n)), n.onTouchStart = n.onTouchStart.bind(m(n)), n.onTouchMove = n.onTouchMove.bind(m(n)), n.onTouchEnd = n.onTouchEnd.bind(m(n)), n.rootDOM = N.a.createRef(), n.state = c(t), n;
    }

    var n, i, e;
    return function (t, n) {
      if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(n && n.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), n && P(t, n);
    }(o, N.a.Component), n = o, (i = [{
      key: "componentDidMount",
      value: function value() {
        this.smartSliding(), this.setRemovalTimeout(this.props.notification.dismiss);
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        this.timeoutId && (this.timeoutId = clearTimeout(this.timeoutId));
      }
    }, {
      key: "setDismissTimeout",
      value: function value(t) {
        var e = this;
        this.timeoutId = setTimeout(function () {
          var t = e.props,
              n = t.notification,
              i = t.toggleTimeoutRemoval;
          n.stage !== h && n.stage !== T && e.setState({
            rootElementStyle: k(n, e.rootDOM.current.scrollHeight)
          }, function () {
            return requestAnimationFrame(function () {
              return i(n);
            });
          });
        }, t);
      }
    }, {
      key: "setRemovalTimeout",
      value: function value(t) {
        t && 0 < t.duration && this.setDismissTimeout(t.duration);
      }
    }, {
      key: "onTransitionEnd",
      value: function value() {
        var t = this.props.notification,
            n = t.animationIn,
            i = A(t);
        i.push("notification-visible"), i = i.concat(n || []), this.setState({
          animatedElementClasses: i,
          rootElementStyle: {
            height: "auto",
            width: I(t.width)
          }
        });
      }
    }, {
      key: "onTouchSmartSlidingEnd",
      value: function value(t) {
        t.stopPropagation(), t.target.isSameNode(this.rootDOM.current) && (this.endOfSmartSliding && this.props.toggleRemoval(this.props.notification), this.endOfSmartSliding = !0);
      }
    }, {
      key: "onSmartSlidingEnd",
      value: function value() {
        var t = this.props.notification;
        t.animationOut && t.animationOut.length && !this.endOfSmartSliding || this.props.toggleRemoval(t), this.endOfSmartSliding = !0;
      }
    }, {
      key: "smartSliding",
      value: function value() {
        var t = this.props.notification,
            n = t.slidingEnter,
            i = A(t),
            e = {
          transition: t.resized ? void 0 : s(n.duration, n.cubicBezier, n.delay),
          width: I(t.width),
          height: "".concat(this.rootDOM.current.scrollHeight, "px")
        };
        !t.resized && t.animationIn && 0 < t.animationIn.length && t.animationIn.forEach(function (t) {
          return i.push(t);
        }), this.setState({
          rootElementStyle: e,
          animatedElementClasses: i
        });
      }
    }, {
      key: "onNotificationClick",
      value: function value() {
        var t = this,
            n = this.props.notification,
            i = k(n, this.rootDOM.current.scrollHeight);
        this.setState({
          rootElementStyle: i
        }, function () {
          return requestAnimationFrame(function () {
            t.props.onClickHandler(n);
          });
        });
      }
    }, {
      key: "onTouchStart",
      value: function value(t) {
        this.setState({
          startX: t.touches[0].pageX,
          currentX: t.touches[0].pageX
        });
      }
    }, {
      key: "onTouchMove",
      value: function value(t) {
        var n,
            i,
            e = this.props,
            o = e.notification,
            r = e.toggleTouchEnd,
            a = t.touches[0].pageX - this.state.startX;
        (n = a, i = Math.abs(n), .4 * window.innerWidth <= i) ? this.setState({
          animatedElementClasses: A(o),
          rootElementStyle: k(o, this.rootDOM.current.scrollHeight)
        }, function () {
          requestAnimationFrame(function () {
            return r(o);
          });
        }) : this.setState({
          currentX: t.touches[0].pageX,
          childElementStyle: {
            position: "relative",
            left: "".concat(0 + a, "px")
          }
        });
      }
    }, {
      key: "onTouchEnd",
      value: function value() {
        var t = this.props.notification.touchSlidingBack;
        this.setState({
          childElementStyle: {
            left: "0",
            position: "relative",
            transition: s(t.duration, t.cubicBezier, t.delay, "left")
          }
        });
      }
    }, {
      key: "render",
      value: function value() {
        var t = this.props.notification,
            n = this.state.childElementStyle,
            i = this.onAnimationEnd,
            e = null,
            o = !1,
            r = this.state.hasSliding ? this.onTransitionEnd : null,
            a = p(t, this.state),
            c = (a.animatedElementClasses || []).join(" "),
            s = a.rootElementStyle;
        if (t.dismissable.click && (e = this.onNotificationClick), t.stage === h ? (i = null, s = k(t, this.rootDOM.current.scrollHeight)) : t.stage === S ? (i = this.onSmartSlidingEnd, r = this.onSmartSlidingEnd) : t.stage === T && (i = this.onTouchSmartSlidingEnd, r = this.onTouchSmartSlidingEnd, e = null, n = a.childElementStyle, o = !0), t.content) return N.a.createElement("div", {
          onTouchStart: o ? null : this.onTouchStart,
          onTouchMove: o ? null : this.onTouchMove,
          onTouchEnd: o ? null : this.onTouchEnd,
          onTouchCancel: o ? null : this.onTouchEnd,
          onClick: e,
          className: "notification-item-root",
          onAnimationEnd: i,
          onTransitionEnd: r,
          ref: this.rootDOM,
          style: s
        }, N.a.createElement("div", {
          className: "".concat(c, " notification-item-child"),
          style: n
        }, t.content));
        var u,
            l,
            f,
            d = N.a.createElement("div", {
          className: "notification-close",
          onClick: this.onNotificationClick
        }, N.a.createElement("span", null, "×")),
            m = t.dismissIcon ? (u = t, l = this.onNotificationClick, u.dismissIcon ? N.a.createElement("div", {
          className: u.dismissIcon.className,
          onClick: l
        }, u.dismissIcon.content) : N.a.createElement("div", {
          className: "notification-close",
          onClick: l
        }, N.a.createElement("span", null, "×"))) : d;
        return t.title && (f = N.a.createElement("h4", {
          className: "notification-title"
        }, t.title)), N.a.createElement("div", {
          onTouchStart: o ? null : this.onTouchStart,
          onTouchMove: o ? null : this.onTouchMove,
          onTouchEnd: o ? null : this.onTouchEnd,
          onTouchCancel: o ? null : this.onTouchEnd,
          onClick: e,
          className: "notification-item-root",
          onAnimationEnd: i,
          onTransitionEnd: r,
          ref: this.rootDOM,
          style: s
        }, N.a.createElement("div", {
          className: "".concat(c, " notification-item-child"),
          style: n
        }, N.a.createElement("div", {
          className: "notification-content"
        }, m, f, N.a.createElement("p", {
          className: "notification-message"
        }, this.props.notification.message))));
      }
    }]) && f(n.prototype, i), e && f(n, e), o;
  }(),
      U = i(1),
      x = i.n(U);

  i(4);

  function G(t) {
    return (G = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
      return _typeof(t);
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
    })(t);
  }

  function j(t) {
    return function (t) {
      if (Array.isArray(t)) {
        for (var n = 0, i = new Array(t.length); n < t.length; n++) {
          i[n] = t[n];
        }

        return i;
      }
    }(t) || function (t) {
      if (Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t)) return Array.from(t);
    }(t) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance");
    }();
  }

  function z(t, n) {
    for (var i = 0; i < n.length; i++) {
      var e = n[i];
      e.enumerable = e.enumerable || !1, e.configurable = !0, "value" in e && (e.writable = !0), Object.defineProperty(t, e.key, e);
    }
  }

  function F(t) {
    return (F = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
      return t.__proto__ || Object.getPrototypeOf(t);
    })(t);
  }

  function H(t) {
    if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t;
  }

  function X(t, n) {
    return (X = Object.setPrototypeOf || function (t, n) {
      return t.__proto__ = n, t;
    })(t, n);
  }

  var q = function (t) {
    function o(t) {
      var n, i, e;
      return function (t, n) {
        if (!(t instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, o), i = this, (n = !(e = F(o).call(this, t)) || "object" !== G(e) && "function" != typeof e ? H(i) : e).state = {
        isMobile: t.isMobile,
        breakpoint: t.breakpoint,
        notifications: []
      }, R(t.types) && (n.state.userDefinedTypes = t.types), n.addNotification = n.addNotification.bind(H(n)), n.onNotificationClick = n.onNotificationClick.bind(H(n)), n.toggleRemoval = n.toggleRemoval.bind(H(n)), n.toggleTimeoutRemoval = n.toggleTimeoutRemoval.bind(H(n)), n.handleResize = n.handleResize.bind(H(n)), n.renderReactNotifications = n.renderReactNotifications.bind(H(n)), n.toggleTouchEnd = n.toggleTouchEnd.bind(H(n)), n;
    }

    var n, i, e;
    return function (t, n) {
      if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(n && n.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), n && X(t, n);
    }(o, N.a.Component), n = o, (i = [{
      key: "componentDidMount",
      value: function value() {
        var t = this;
        this.setState({
          width: window.innerWidth
        }, function () {
          window.addEventListener("resize", t.handleResize);
        });
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        this.mounted = !1;
      }
    }, {
      key: "handleResize",
      value: function value() {
        this.setState({
          width: window.innerWidth,
          notifications: this.state.notifications.map(function (t) {
            return t.resized = !0, t;
          })
        });
      }
    }, {
      key: "toggleTimeoutRemoval",
      value: function value(n) {
        var i = S,
            e = r.TIMEOUT;
        this.setState({
          notifications: this.state.notifications.map(function (t) {
            return t.id === n.id && (t.stage = i, t.removedBy = e), t;
          })
        });
      }
    }, {
      key: "addNotification",
      value: function value(t) {
        var n = u(t, this.state.userDefinedTypes);
        return this.setState(function (t) {
          return {
            notifications: n.insert === a.TOP ? [n].concat(j(t.notifications)) : [].concat(j(t.notifications), [n])
          };
        }), n.id;
      }
    }, {
      key: "removeNotification",
      value: function value(n) {
        var t = this;
        this.setState({
          notifications: this.state.notifications.map(function (t) {
            return t.id === n && (t.stage = h, t.removedBy = r.API), t;
          })
        }, function () {
          requestAnimationFrame(function () {
            t.setState({
              notifications: t.state.notifications.map(function (t) {
                return t.id === n && (t.stage = S, t.removedBy = r.API), t;
              })
            });
          });
        });
      }
    }, {
      key: "onNotificationClick",
      value: function value(n) {
        var t = this,
            i = n.dismissable,
            e = n.dismissIcon;
        (i && i.click || e) && requestAnimationFrame(function () {
          t.setState({
            notifications: t.state.notifications.map(function (t) {
              return t.id === n.id && (t.stage = S, t.removedBy = r.CLICK), t;
            })
          });
        });
      }
    }, {
      key: "toggleTouchEnd",
      value: function value(n) {
        var i = T;
        this.setState({
          notifications: this.state.notifications.map(function (t) {
            return t.id === n.id && (t.stage = i, t.removedBy = r.TOUCH), t;
          })
        });
      }
    }, {
      key: "toggleRemoval",
      value: function value(n) {
        var t = this;
        this.setState({
          notifications: this.state.notifications.filter(function (t) {
            return t.id !== n.id;
          })
        }, function () {
          t.props.onNotificationRemoval && t.props.onNotificationRemoval(n.id, n.removedBy);
        });
      }
    }, {
      key: "renderReactNotifications",
      value: function value(n) {
        var i = this;
        return n.map(function (t) {
          return N.a.createElement(L, {
            key: t.id,
            notification: t,
            isFirstNotification: 1 === n.length,
            onClickHandler: i.onNotificationClick,
            toggleRemoval: i.toggleRemoval,
            toggleTimeoutRemoval: i.toggleTimeoutRemoval,
            toggleTouchEnd: i.toggleTouchEnd
          });
        });
      }
    }, {
      key: "render",
      value: function value() {
        var t,
            i,
            e,
            n = this.state;

        if (this.props.isMobile && n.width <= n.breakpoint) {
          var o = (t = n.notifications, i = [], e = [], t.forEach(function (t) {
            var n = t.container.toLowerCase();
            if (M(n)) e.push(t);else {
              if (!C(n)) throw new Error("Container ".concat(t.container, " is not valid"));
              i.push(t);
            }
          }), {
            top: e,
            bottom: i
          }),
              r = this.renderReactNotifications(o.top),
              a = this.renderReactNotifications(o.bottom);
          return N.a.createElement("div", {
            className: "react-notification-root"
          }, N.a.createElement("div", {
            className: "notification-container-mobile-top"
          }, r), N.a.createElement("div", {
            className: "notification-container-mobile-bottom"
          }, a));
        }

        var c,
            s,
            u,
            l,
            f,
            d,
            m,
            h = (c = n.notifications, s = [], u = [], l = [], f = [], d = [], m = [], c.forEach(function (t) {
          var n = t.container.toLowerCase();
          if (n === g.TOP_LEFT) s.push(t);else if (n === g.TOP_RIGHT) u.push(t);else if (n === g.TOP_CENTER) l.push(t);else if (n === g.BOTTOM_LEFT) f.push(t);else if (n === g.BOTTOM_RIGHT) d.push(t);else {
            if (n !== g.BOTTOM_CENTER) throw new Error("Container ".concat(t.container, " is not valid"));
            m.push(t);
          }
        }), {
          topLeft: s,
          topRight: u,
          topCenter: l,
          bottomLeft: f,
          bottomRight: d,
          bottomCenter: m
        }),
            p = this.renderReactNotifications(h.topLeft),
            E = this.renderReactNotifications(h.topRight),
            S = this.renderReactNotifications(h.topCenter),
            T = this.renderReactNotifications(h.bottomLeft),
            y = this.renderReactNotifications(h.bottomRight),
            I = this.renderReactNotifications(h.bottomCenter);
        return N.a.createElement("div", {
          className: "react-notification-root"
        }, N.a.createElement("div", {
          className: "notification-container-top-left"
        }, p), N.a.createElement("div", {
          className: "notification-container-top-right"
        }, E), N.a.createElement("div", {
          className: "notification-container-bottom-left"
        }, T), N.a.createElement("div", {
          className: "notification-container-bottom-right"
        }, y), N.a.createElement("div", {
          className: "notification-container-top-center"
        }, S), N.a.createElement("div", {
          className: "notification-container-bottom-center"
        }, I));
      }
    }]) && z(n.prototype, i), e && z(n, e), o;
  }();

  q.propTypes = {
    isMobile: x.a.bool,
    breakpoint: x.a.number,
    types: x.a.array,
    onNotificationRemoval: x.a.func
  }, q.defaultProps = {
    isMobile: !0,
    breakpoint: 768
  };
  n.default = q;
}]);